import React from "react";

import { usePlayer } from "./hooks";

import styles from "./style.module.scss";

export const Player = React.memo(() => {
  const { values } = usePlayer();
  return <video className={styles[values.content]} id="player" muted playsInline />;
});

Player.displayName = "Player";
